export const TAB_KEYS = {
  quoteDetails: 'quoteDetailsForm',
  stops: 'stopsForm',
  productDetails: 'productForm',
  shippingTerms: 'shippingTermsSearchForm',
  notes: 'notesForm',
  collaborators: 'collaborators',
  bidding: 'bidding',
  documents: 'documentForm',
};

export const QUOTE_STATUSES = {
  new: 'New',
  internalReview: 'Internal Review',
  openForBid: 'Open for Bid',
  readyForAward: 'Ready for Award',
  awarded: 'Awarded',
  cancelled: 'Cancelled',
  unAwarded: 'Unawarded',
};

export const formsName = [
  'quoteDetailsForm',
  'stopsForm',
  'productForm',
  'shippingTermsSearchForm',
  'notesForm',
  'documentForm',
];

export const formsButtons = { save: 'saveQuoteForm', spotBid: 'spotBidForm', sendForReview: 'sendForReviewForm' };

export const USER_ROLES = {
  admin: 'Halliburton Admin',
  creator: 'Halliburton Creator',
  approver: 'Halliburton Approver',
};

export const defaultTime = { hour: 12, minute: 0, second: 0 };

export const quoteElements = {
  currency: 'currency',
  collaborators: 'collaborators',
  bidDuration: 'bidDuration',
  transportationAddress: 'transportationAddress',
  transportationDetails: 'transportationDetails',
  productDetails: 'productDetails',
  shippingTerms: 'shippingTerms',
  bidding: 'bidding',
  shippingDates: 'shippingDates',
  deliveryDate: 'deliveryDate',
  notes: 'notes',
  addFile: 'addFile',
  removeFile: 'removeFile',
};
